export default {
  state: {
    macroAnimation: {},
    voiceOverTime: 0,
    totalVoiceOverTime: 0,
    animationPlaying: false,
    totalWaitTime: 0,
    waitProgress: 0,
    showMacroAnimation: false,
    animationObj: {},
    activeNavIdx: null,
    openMenu: false,
    playTimout: undefined
  },
  mutations: {
    setMacroAnimation(state, payload) {
      state.macroAnimation = payload;
    },
    clearMacroAnimation(state) {
      state.macroAnimation = {};
    },
    updateVoiceOverTime(state, payload) {
      state.voiceOverTime = payload;
    },
    setTotalVoiceOverTime(state, payload) {
      state.totalVoiceOverTime = payload;
    },
    updateAnimationPlaying(state, payload) {
      state.animationPlaying = payload;
    },
    updateTotalWaitTime(state, payload) {
      state.totalWaitTime = payload;
    },
    updateWaitProgress(state, payload) {
      state.waitProgress = payload;
    },
    updateShowMacroAnimation(state, payload) {
      state.showMacroAnimation = payload;
    },
    updateAnimationObj(state, payload) {
      state.animationObj = payload;
    },
    updateActiveNavIdx(state, payload) {
      state.activeNavIdx = payload;
    },
    updateOpenMenu(state, payload) {
      state.openMenu = payload;
    },
    updatePlayTimeout(state, payload) {
      state.playTimout = payload;
    }
  },
  actions: {
    findMacroAnimation({ commit, rootState }, id) {
      var animationFound = rootState.macroAnimations[id];
      commit("setMacroAnimation", animationFound);
    }
  }
};
